// RU / RO language switcher. Persists the choice the same way the rest of the
// app does (localStorage key "lng") and updates the shared i18n instance.

import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RAFFLE_NS } from './translations';

const LANGS = ['ru', 'ro'];

const LanguageSwitcher = ({ className = '' }) => {
  const { t, i18n } = useTranslation(RAFFLE_NS);
  const current = LANGS.includes(i18n.language) ? i18n.language : 'ru';

  const changeLanguage = useCallback(
    (lang) => {
      if (lang === i18n.language) return;
      i18n.changeLanguage(lang);
      try {
        localStorage.setItem('lng', lang);
      } catch (e) {
        /* ignore storage errors */
      }
    },
    [i18n]
  );

  return (
    <div
      className={`rf-lang ${className}`}
      role="group"
      aria-label={t('lang.label')}
    >
      <span className="rf-lang__thumb" data-active={current} aria-hidden="true" />
      {LANGS.map((lang) => (
        <button
          key={lang}
          type="button"
          className="rf-lang__btn"
          aria-pressed={current === lang}
          aria-label={t(`lang.${lang}Full`)}
          onClick={() => changeLanguage(lang)}
        >
          {t(`lang.${lang}`)}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
